import { Typography,Box } from "@mui/material";
import { useState,useEffect } from "react";
import CoursesBlog from "../../../../Blog/courses-blog.component";
import { getCoursesFifthCard } from "../../../../../utils/firebase/firebase.utils";
import { Helmet } from "react-helmet-async";

const CoursesFifthCard = ()=>{

    const [courseData,setCourseData] = useState([]);

    useEffect(()=>{
        const getData = async()=>{
            const arrayData = await getCoursesFifthCard();
            const{data} = arrayData;
            setCourseData(data.reverse());
        
        }

        getData();
        
        
    },[])




    return(
        <>
        <Helmet>
                <title> Online WBCS Coaching | Ahguide  </title>
                <meta name="description" content="Our Live Classes is dedicated platform that offers Online WBCS Coaching Classes for entire WBCS examinations." />        
                <link rel="canonical"  href="https://www.ahguide.in/online-wbcs-coaching" />
            </Helmet>
        
        <Box>
            <Typography sx={{textAlign:"center",marginTop:'20px'}} variant="h3" component="div">
                Online WBCS Coaching
            </Typography>
            {
                courseData.map((data)=>{
                    return  <CoursesBlog key={data.title} courseData= {data}  />
                })
            }

        </Box>
        </>
    )

}

export default CoursesFifthCard;